import sendLetterContentFactory from './services/letters/sendLetterContent';
import getNextLetter from './services/letters/getNextLetter';
import getLetterByReference from './services/letters/getLetterByReference';
import openAddNoteModalFactory from '../tasks/services/notes/openAddNoteModal';
import addNoteFactory from '../tasks/services/notes/addNote';
import getScannedLetter from './services/letters/getScannedLetter';
import uploadScannedLetter from './services/upload/uploadScannedLetter';
import skipLetter from './services/letters/skipLetter';
import registerRoutes from './routes';

export default function (app) {
    app.factory('sendLetterContent', sendLetterContentFactory);
    app.factory('getNextLetter', getNextLetter);
    app.factory('getLetterByReference', getLetterByReference);
    app.factory('openAddNoteModal', openAddNoteModalFactory);
    app.factory('addNote', addNoteFactory);
    app.factory('getScannedLetter', getScannedLetter);
    app.factory('uploadScannedLetter', uploadScannedLetter);
    app.factory('skipLetter', skipLetter);
    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/index.js